<template>
  <div>
    <el-dropdown size="small" class="d2-mr">
      <span class="btn-text">{{info.name ? `你好 ${info.name}` : '未登录'}}</span>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item @click.native="logOff">
          <d2-icon name="power-off" class="d2-mr-5" />注销
        </el-dropdown-item>
        <!-- <el-dropdown-item @click.native="changePassword">
          <d2-icon name="power-off" class="fa-lock" />修改密码
        </el-dropdown-item> -->
      </el-dropdown-menu>
    </el-dropdown>
    <el-dialog title="修改密码" :visible.sync="dialogFormVisible" width="500px">
      <el-form :model="form" ref="form" :rules="rule">
        <el-form-item label="旧密码" label-width="120px" prop="oldPass">
          <el-input type="password" v-model="form.oldPass" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="新密码" label-width="120px" prop="newPass">
          <el-input type="password" v-model="form.newPass" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="确认密码" label-width="120px" prop="confirmPass">
          <el-input type="password" v-model="form.confirmPass" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirmChange">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { flscPost } from '@api/shop'
export default {
  data () {
    return {
      dialogFormVisible: false,
      form: {
        oldPass: '',
        newPass: '',
        confirmPass: ''
      },
      rule: {
        oldPass: [
          { type: 'string', required: true, message: '请输入旧密码', trigger: 'blur' }
        ],
        newPass: [
          { type: 'string', required: true, message: '请输入新密码', trigger: 'blur' }
        ],
        confirmPass: [
          { type: 'string', required: true, message: '请输入确认密码', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    ...mapState('d2admin/user', [
      'info'
    ])
  },
  methods: {
    ...mapActions('d2admin/account', [
      'logout'
    ]),
    /**
     * @description 登出
     */
    logOff () {
      this.logout({
        confirm: true
      })
    },
    changePassword () {
      this.dialogFormVisible = true
      if (this.$refs.form !== undefined) {
        this.$refs.form.resetFields()
      }
    },
    confirmChange () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          flscPost({
            app: 'index',
            mod: 'sldChangePsd'
          },
          {
            old_pw: this.form.oldPass,
            new_pw: this.form.newPass,
            new_pw2: this.form.confirmPass
          }).then(res => {
            this.$notify({
              message: res.msg,
              type: 'success',
              duration: 2000
            })
            if (res.state !== 255) {
              this.dialogFormVisible = false
            }
          })
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 22px;
}
</style>

<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/layout/header-aside/components/header-user/index.vue"
}
</vue-filename-injector>
